import Personal from "./Personal";
import { ProfileJourneyProvider } from "./ProfileJourneyContext";
import Professional from "./Professional";
import Educational from "./Educational";
import Journey from "../../Layouts/Journey";

export default Journey({ journeyTitle: "Complete Your Profile", Provider: ProfileJourneyProvider, finalRoute: "/" }, Personal, Professional, Educational);